import { useEffect, useState } from "react";
import MobileAppSection from "../../components/pages/home/mobile-app-section/MobileAppSection";
import Countries from "../../components/shared/countries/Countries";
import TitleUpdater from "../../components/shared/title/TitleUpdater";
import { DangerousGoodsService } from "../../services/dangeroues_goods.service";
import styles from "./ForbiddenProducts.module.scss";
import { DangerousGoodsDataType } from "../../interface/site.interface";
import Spinner from "../../components/shared/spinner/Spinner";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";

const ForbiddenProducts = () => {
  const language = useSelector((state: RootState) => state.language.language);

  const [goodsData, setGoodsData] = useState<
    Record<string, DangerousGoodsDataType>
  >({});
  const [selectedKey, setSelectedKey] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const { data } = useSelector((state: RootState) => state.translationData);

  useEffect(() => {
    setLoading(true);
    DangerousGoodsService.getAllDangerousGoods()
      .then((res) => {
        const data = res?.data?.original;
        setGoodsData(data);

        const firstKey = Object.keys(data)[0];
        if (firstKey) setSelectedKey(firstKey);
      })
      .catch(() => console.log("err"))
      .finally(() => setLoading(false));
  }, [language]);

  const handleCountryChange = (countryKey: string) => {
    if (goodsData[countryKey]) {
      setSelectedKey(countryKey);
    }
  };

  const currentCountryData = goodsData[selectedKey];

  return (
    <div id={styles.forbidden_products}>
      <TitleUpdater
        title={
          data?.colibri && data?.prohibited_items
            ? `${data?.colibri} | ${data?.prohibited_items}`
            : "Colibri"
        }
      />
      <div className="container">
        <div className={styles.forbidden_section}>
          <h1 className={styles.section_title}>{data?.prohibited_items}</h1>
          {loading ? (
            <Spinner size="large" />
          ) : (
            <div>
              <div className={styles.name_buttons}>
                <Countries onCountrySelect={handleCountryChange} />
              </div>

              {currentCountryData && (
                <div className={styles.descriptionContent}>
                  <div
                    className={styles.descriptionText}
                    dangerouslySetInnerHTML={{
                      __html: currentCountryData.title,
                    }}
                  />
                </div>
              )}
            </div>
          )}
        </div>
        <MobileAppSection />
      </div>
    </div>
  );
};

export default ForbiddenProducts;
